// icon:bx-fullscreen | Boxicons https://boxicons.com/ | Atisa
import * as React from "react";

function IconFullscreen(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      height="1em"
      width="1em"
      {...props}
    >
      <path d="M5 5h5V3H3v7h2zm5 14H5v-5H3v7h7zm11-5h-2v5h-5v2h7zm-2-4h2V3h-7v2h5z" />
    </svg>
  );
}

export default IconFullscreen;
